import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

const Header = ({
  colorMode,
  tenant,
  title,
  pubDate,
  oberzeile,
  lead,
}: {
  colorMode: 'light' | 'dark' | undefined
  tenant: Tenant
  title: string
  pubDate: string
  oberzeile: string
  lead: string
}) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  return (
    <HeaderContainer>
      <HeaderImage
        src={
          isMobile
            ? require('../../images/header_mob' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg')
            : require('../../images/header_3' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg')
        }
      />
      {/* <Title>
        <h2>
          <span className='oberzeile'>{oberzeile}</span>
          {title}
        </h2>
        <h3 className='lead'>{lead}</h3>
      </Title>
      <Authors colorMode={colorMode}>
        <span key={83371228}>
          <a
            href={`https://www.${
              tenant.key
            }.ch/author/${83371228}/marc-brupbacher`}
            style={{ background: 'none' }}
          >
            Marc Brupbacher
          </a>
        </span>
        ,{' '}
        <span key={84880321}>
          <a
            href={`https://www.${
              tenant.key
            }.ch/author/${84880321}/sebastian-broschinski`}
            style={{ background: 'none' }}
          >
            Sebastian Broschinski
          </a>
        </span>
        <Publication colorMode={colorMode}>{pubDate}</Publication>
      </Authors> */}
    </HeaderContainer>
  )
}
const HeaderContainer = styled.div`
  position: relative;
  /* margin-bottom: 60px; */
`
const Title = styled.div`
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'Suez One', serif;
  font-size: 40px;
  text-align: center;
  line-height: 1.2em;
  /* text-shadow: 2px 2px 0px #fff, 2px -2px 0px #fff, -2px -2px 0px #fff,
    -2px 2px 0px #fff; */
  color: var(--text-color);
  background-color: var(--header-bg);
  padding: 20px 30px;
  padding-bottom: 40px;
  border-radius: 15px;
  width: 668px;
  @media screen and (max-width: 711px) {
    width: calc(100% - 40px);
    font-size: 26px;
    bottom: 80px;
    /* bottom: unset; */
    /* top: 64%; */
  }
  h2 {
    margin:0;
    padding: 0;
    font-size: 40px;
    line-height: 1.2em;
    /* margin-bottom: 10px; */
    @media screen and (max-width: 711px) {
      font-size: 26px;
      margin-bottom: 5px;
    }
  }
  box-shadow: var(--header-shadow);

  span.oberzeile {
    display: inline-block;
    width: 100%;
    font-family: var(--font-sans-serif);
    font-size: 18px;
    color: #ff1ade;
    line-height: 1.4em;
    @media screen and (max-width: 711px) {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
  h3 {
    margin:0;
    padding:0;
    padding-top: 30px;
font-weight: 400;;
    display: inline-block;
    width: 100%;
    font-family: var(--font-sans-serif);
    font-size: 18px;
    /* color: #ff1ade; */
    line-height: 1.5em;
    @media screen and (max-width: 711px) {
      font-size: 15px;
      padding-top: 10px;
    }
  }
`

export default Header
const HeaderImage = styled.img`
  max-width: 100%;
  width: 1000px;
  margin-left: auto;
  margin-right: auto;
  z-index: 0;
`
const Authors = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  width: 100%;
  margin-top: 15px;
  position: absolute;
  bottom: 0;
  text-align: center;
  z-index: 100;
  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  /* border-top: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'}; */
  /* padding-top: 2rem; */

  button {
    &:hover {
      cursor: pointer;
    }
    padding: 0;
    border: 0;
    background-color: transparent;
  }
  a,
  button {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span {
    white-space: nowrap;
    cursor: pointer;
  }
  span::after {
    /* content: ', '; */
  }
  span:last-child::after {
    content: '';
  }
`
const Publication = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  font-size: 12px;
  color: var(--gray-3);
  font-family: var(--font-sans-serif);
  /* margin-bottom: 60px; */
  line-height: 2em;
  text-align: center;
`
